import { Heading, Spinner, Text, VStack } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";

import CenteredLayout from "@/common/components/CenteredLayout";
import { useCreateAppMutation } from "@/common/data/useCreateAppMutation";
import { useErrorToast } from "@/common/hooks/useErrorToast";
import { useSlugParam } from "@/common/hooks/useParam";
import { FeaturesUrl } from "@reflag/shared/urls";

export default function GenerateDemoApp() {
  const { orgId } = useSlugParam("org");
  const errorToast = useErrorToast();
  const navigate = useNavigate();

  const creatingDemoApp = useRef(false);

  const createDemoApp = useCreateAppMutation(orgId, {
    onSuccess: (app) => {
      // we just created a new app which doesn't exist in the bootstrap
      // data yet, so we do a full page reload to get the new data here.
      window.location.assign(FeaturesUrl(app.environments[0]));
    },
    onError: () => {
      errorToast({
        title: "Could not create app",
      });
      navigate("/");
    },
  });

  useEffect(() => {
    if (creatingDemoApp.current) {
      return;
    }

    creatingDemoApp.current = true;
    // start creating. The server uses an advisory lock to return the existing demo app if one was already created.
    createDemoApp.mutate({
      name: "B2B demo app",
      demoData: true,
    });
  }, [createDemoApp, orgId, navigate]);

  return (
    <CenteredLayout showReflagLogo>
      <Helmet>
        <title>Get Started</title>
      </Helmet>
      <VStack spacing={6}>
        <Spinner />
        <VStack spacing={3}>
          <Heading fontSize="2xl">Hang tight!</Heading>
          <Text color="dimmed">Generating a demo app for you.</Text>
        </VStack>
      </VStack>
    </CenteredLayout>
  );
}
